// @flow

// list of airlines with mobile boarding pass
export const AIRLINES_WITH_MOBILE_BOARDING_PASS = ["FR", "OE", "W6", "W9"]

export default {
  PROVIDE_DETAILS: "provide_details",
  WAITING_FOR_DETAILS: "waiting_for_details",
  WAITING_FOR_CHECKIN: "waiting_for_checkin",
  PROCESSING: "processing",
  DONE: "done",
  MISSED: "missed",
  FAILED: "failed",
  RESTRICTED: "restricted",
  UNAVAILABLE: "unavailable",
  SOME_CHECKINS_PROCESSING_SOME_MISSED: "some_checkins_processing_some_missed",
  SOME_CHECKINS_DONE_SOME_MISSED: "some_checkins_done_some_missed",
  SOME_CHECKINS_MISSED_SOME_FAILED: "some_checkins_missed_some_failed",
  SOME_CHECKINS_DONE_SOME_PROCESSING: "some_checkins_done_some_processing",
  SOME_CHECKINS_DONE_SOME_FAILED: "some_checkins_done_some_failed",
  SOME_CHECKINS_DONE_SOME_WAITING_FOR_DETAILS: "some_checkins_done_some_waiting_for_details",
  OTHER: "other",
  GROUND_DONE: "ground_done",
  GROUND_PROCESSING: "ground_processing",
  GROUND_UNAVAILABLE: "ground_unavailable",
}
